// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"283e3c5d","453":"9194a27c"}[chunkId] + ".chunk.js";
};